import { render, staticRenderFns } from "./reset-password-form-modal.vue?vue&type=template&id=2ae733e4&"
import script from "./reset-password-form-modal.vue?vue&type=script&lang=js&"
export * from "./reset-password-form-modal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports